import Card from '../Card/Card';
import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const UploaderCard = styled(Card)`
  border: 1px dashed ${colors['blackText']};
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
`;

export { UploaderCard };
